const CardsPedidosSaques = () => {
    return(
      <article className="card">
        <div className="card-header">
          <div className="card-title">
            <span>💰</span>
            <span>Pedidos de saque pendentes</span>
          </div>
          <span className="pill">Resumo</span>
        </div>
        <div className="card-body">
          <div className="card-value" id="saquesPendentes">0</div>
          <div className="card-sub">
            Total de licenciados com pedidos de saque em análise.  
            Detalhamento completo na tela de “Pedidos de saque”.
          </div>
        </div>
      </article>
    )
}

export default CardsPedidosSaques;